import { Data, LookupBase, Model } from '@singularsystems/neo-core';
import DividendAccrualDetailLookup from './DividendAccrualDetailLookup';

export default class DividendAccrualDetailResponse {

    public page: Data.PageResult<Model.PlainObject<DividendAccrualDetailLookup>> | null = null;

    public info: Model.PlainObject<DividendAccrualDetailInfo> | null = null;

    // Client only properties / methods
}

export class DividendAccrualDetailInfo extends LookupBase {

    constructor() {
        super();

        this.makeBindable();
    }

    public hasExpiredExemptions: boolean = false;

    public willReinvest: boolean = false;

    // Client only properties / methods
}